/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Body from 'solis/react/layout/body';
import Pane from 'solis/react/layout/pane';


const Root = styled(Flex)`

  width: 100vw;
  height: 100vh;

  position: relative;
`;


const Content = styled(Flex)`

  flex-grow: 1;

  position: relative;
  overflow: hidden;
`;


export default ({ pane, body, toolbar, title, badge, overlay }) =>
(
  <Root>

    <Content>

      <Pane pane = {pane} title = {title} badge = {badge} />
      <Body body = {body} toolbar = {toolbar} overlay = {overlay} />

    </Content>

  </Root>
);
